import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pagination from 'components/ui/pagination';

import Button from 'shared/button';
import PageHeader from 'components/ui/page_header';
import LoadingSpinner from 'components/ui/loading_spinner';
import AggregateView from 'components/importer/aggregate_view';
import Table from './table';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

import { post } from 'helpers/api';
import { retrieveImports } from '../store/actions/search';
import { changeImportPage } from '../store/actions/query';
import { getImports, isFetching } from '../store/selectors/search';
import { getImportsPath } from '../store/selectors/paths';
import { getAggregateView } from '../store/selectors/static';
import { getCurrentPage, getTodalPages } from '../store/selectors/search';

export function ImportsList({
  aggregateView,
  currentPage,
  imports,
  importsPath,
  isFetching,
  onPageChange,
  retrieveRecords,
  totalPages
}) {
  useEffect(() => {
    !aggregateView && retrieveRecords();
  }, []);

  const handleNewImport = () => {
    const params = { importerImport: { ownerType: 'data_imports_team' } };

    post(importsPath, params).then((response) => {
      window.location.href = response.import.importPath;
    });
  };

  const handlePageChange = (page) => {
    onPageChange(page);
    retrieveRecords();
  };

  const renderResults = () => {
    if (isFetching) {
      return <LoadingSpinner/>;
    } else if (imports.length > 0) {
      return <Table imports={imports} />;
    }
    return (
      <Empty className="bg-white">
        <Empty.Title>You haven't imported anything yet</Empty.Title>
        <Empty.Actions>
          <Button.Primary label="Start your first import" plain onClick={handleNewImport} />
        </Empty.Actions>
      </Empty>
    );
  };

  const renderPagination = () => {
    if (isFetching || totalPages <= 1)  {
      return null;
    }

    return (
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={handlePageChange}
      />
    );
  };

  const renderBody = () => {
    if (aggregateView) {
      return <AggregateView/>;
    }
    return renderResults();
  };

  return (
    <>
      <PageHeader containerWidth>
        <PageHeader.Heading description="Import contacts, companies and properties" title="Imports" />
        {!aggregateView && (
          <PageHeader.Actions>
            <Button.Primary name="new-import" onClick={handleNewImport}>
              New Import
            </Button.Primary>
          </PageHeader.Actions>
        )}
      </PageHeader>

      <div className="container bg-white shadow px-6 py-4 my-4">
        {renderBody()}
        {renderPagination()}
      </div>
    </>
  );
}

ImportsList.propTypes = {
  aggregateView: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  imports: PropTypes.array.isRequired,
  importsPath: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  retrieveRecords: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  aggregateView: getAggregateView(state),
  currentPage: getCurrentPage(state),
  imports: getImports(state),
  importsPath: getImportsPath(state),
  isFetching: isFetching(state),
  totalPages: getTodalPages(state)
});

const mapDispatchToProps = {
  onPageChange: changeImportPage,
  retrieveRecords: retrieveImports
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportsList);
